export default __webpack_public_path__ + "static/media/data-sources.3f0cddc7.png";